import NextImage, { ImageLoaderProps } from 'next/image';

import {
  ContentfulResizeTypes,
  getContentfulLoader,
} from '../../../helpers/imageLoaders/contentful';
import { ExternalLink } from '../../Clickables/ExternalLink/ExternalLink';
import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';

interface IProps {
  title: string;
  description: string | undefined;
  email: string | undefined;
  logo: string | undefined;
  phoneNumber: string | undefined;
  website: string | undefined;
  buttonLink: string | undefined;
  buttonText: string | undefined;
  imageH: number | undefined;
  imageW: number | undefined;
}

export const AgencyItem = ({
  title,
  description,
  email,
  logo,
  phoneNumber,
  website,
  buttonLink,
  buttonText,
  imageH,
  imageW,
}: IProps) => {
  const aspectWidth = imageW || 200;
  const aspectHeight = imageH || 200;

  const contentfulLoader = ({ src, width, quality }: ImageLoaderProps): string =>
    getContentfulLoader(src, width, aspectWidth, aspectHeight, {
      quality,
      resize: ContentfulResizeTypes.FILL,
    });

  return (
    <div
      className="my-8 flex w-full flex-col rounded-lg bg-tuna-tint px-4 py-6 sm:flex-row sm:px-8"
      data-testid="AgencyItem"
    >
      <div className="mb-4 flex sm:mb-0">
        {logo && (
          <div className="w-col-1 sm:w-col-3 md:w-col-2 relative h-full">
            <NextImage
              alt={title}
              src={logo}
              loader={contentfulLoader}
              height={imageH}
              width={imageW}
              className="h-full object-contain"
              sizes="(min-width: 1680px) 200px, (min-width: 990px) 20vw, (min-width: 600px) 30vw,10vw"
            />
          </div>
        )}
        <Heading as="h3" variant="sm" className="w-col-3 ml-4 sm:hidden">
          {title}
        </Heading>
      </div>

      <div className="sm:w-col-9 md:w-col-10 flex flex-col gap-4 sm:ml-4 sm:gap-6 md:ml-8">
        <div>
          <Heading as="h3" variant="sm" className="hidden sm:block">
            {title}
          </Heading>
          <Text>{description}</Text>
          <div className="flex flex-col gap-4">
            <Text className="m-0 font-semibold">Phone: {phoneNumber}</Text>
            {email && (
              <ExternalLink href={`mailto:${email}`} className="font-semibold" target="blank">
                Email: {email}
              </ExternalLink>
            )}
            {website && (
              <ExternalLink href={website} target="blank">
                Visit website
              </ExternalLink>
            )}
          </div>
        </div>
        {buttonLink && buttonText && (
          <ExternalLink
            variant="buttonPrimary"
            href={buttonLink}
            className="w-full sm:w-max"
            target="blank"
          >
            {buttonText}
          </ExternalLink>
        )}
      </div>
    </div>
  );
};
